import createWrapper from 'components/Common/op-ui-wrappers/createWrapper';
import { IconName } from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';

export type AlertVariants = 'info' | 'warning' | 'success' | 'error' | 'discount' | 'success2' | 'primary';

export interface AlertElementProps {
  variant?: AlertVariants;
  block?: boolean;
  progress?: number;
  btnLabel?: string;
  btnIcon?: IconName;
  heading: string;
  subheading?: string;
  closeable?: boolean;
}

interface OwnProps extends HTMLElement {
  onClick: () => void;
}

const OpAlertNotification = createWrapper<OwnProps>('alert-notification', {
  onClick: 'onalertclick',
});

export function displayAlertNotification(params: AlertElementProps) {
  window.dispatchEvent(
    new CustomEvent('display_alert_notification', {
      detail: params,
      bubbles: true,
      composed: true,
    }),
  );
}

export default OpAlertNotification;
